import React, { useState, useCallback, useRef, useEffect } from 'react';

import DataGrid, { Selection, RowDragging, Column, Editing, Scrolling, Paging, Toolbar, Item, MasterDetail, Export, Summary, TotalItem } from 'devextreme-react/data-grid';
import DropDownButton, { DropDownButtonTypes } from 'devextreme-react/drop-down-button';
import { withLoadPanel } from '../../../utils/withLoadPanel';
import TextBox from 'devextreme-react/text-box';
import './CompetitionSendClubDetails.scss';

import { checkPermission } from '../../../permissions';
import { EditCellTimeComponent, EditCellTimeRender, editCellTimeRender, TimeBox, TimeBoxBold } from '../../utils/time-box/TimeBox';
import { Button, CheckBox, NumberBox } from 'devextreme-react';
import { PerformanceCell } from '../../utils/performance-cell/PerformanceCell';
import { useScreenSize } from '../../../utils/media-query';
import { COMPETITION_STATUS_LIST, exportFormats } from '../../../shared/constants';

import { onExporting } from '../../../utils/exporter';
import { useNavigate } from 'react-router-dom';
import { FALSE } from 'sass';
import { getApiToken } from '../../../utils/authUtils.js';
import axios from 'axios';
import { EntriesClubDetails } from '../entries-club-details/EntriesClubDetails';
import { useMsal } from '@azure/msal-react';
import { openPDFOnDevice } from '../../../utils/pdfUtils';
import notify from 'devextreme/ui/notify';



const Grid = ({ dat, onDataChanged }) => {
    const [data, setData] = useState(dat);

    const dropDownOptions = { width: 'auto' };

    const gridRef = useRef(null);
    const navigate = useNavigate();

    const updateField = (field) => (value) => {
        const newData = { ...data, ...{ [field]: value } };

        onDataChanged(newData);
        setData(newData);
    };
    const onSelectionChanged = (e) => {
        const selectedRows = e.selectedRowKeys;
        const newData = { ...data, ...{ ['sendClubIds']: selectedRows } };
        onDataChanged(newData);
        setData(newData);
    }

    return (
        <DataGrid
            className='results-grid'
            dataSource={data.clubs}
            remoteOperations={false}
            width={'100%'}
            height={'calc(100vh - 250px)'}
            rowAlternationEnabled={true}
            ref={gridRef}
            onContentReady={(e) => {
                // IDs der Zeilen filtern, bei denen sendDate null ist
                const rowsToSelect = data.clubs
                    .filter((club) => club.sendDate === null)
                    .map((club) => club.clubId); // IDs der Zeilen abrufen

                e.component.selectRows(rowsToSelect, true); // Nur gefilterte Zeilen auswählen
            }}
            onSelectionChanged={onSelectionChanged}
            keyExpr={'clubId'}
        //  columnAutoWidth={useScreenSize() === 'xs'}
        >
            <Selection mode='multiple' showCheckBoxesMode='always' />
            <Toolbar>

                <Item location='after' locateInMenu='auto'>
                    <div>
                        <CheckBox
                            text='DSV7/8-Datei  '
                            value={data.dsv7}
                            onValueChange={updateField('dsv7')}
                        />
                    </div>
                </Item>
                <Item location='after' locateInMenu='auto'>
                    <div>
                        <CheckBox
                            text='Lenex-Datei   '
                            value={data.lenex}
                            onValueChange={updateField('lenex')}
                        />
                    </div>
                </Item>
                <Item location='after' locateInMenu='auto'>
                    <div>
                        <CheckBox
                            text='an mich in CC'
                            value={data.meInCC}
                            onValueChange={updateField('meInCC')}

                        />
                    </div>
                </Item>
                <Item location='after' locateInMenu='auto'>
                    <div>
                        <CheckBox
                            text='Direkter Versand an den Ausrichter'
                            value={data.sendToOrganizer}
                            onValueChange={updateField('sendToOrganizer')}

                        />
                    </div>
                </Item>

            </Toolbar>
            <Paging enabled={false} />
            <MasterDetail
                enabled={true}
                component={EntriesClubDetails}
            />

            <Scrolling mode='virtual' />


            <Column
                dataField='clubname'
                caption='Verein'
            />
            <Column
                dataField='mail'
                caption='E-Mail'
            />
            <Column
                dataField='lastname'
                caption='Nachname'
            />
            <Column
                dataField='surname'
                caption='Vorname'
            />

            <Column
                dataField='athletesCount'
                caption='Anzahl Athleten'
            />
            <Column
                dataField='entriesCount'
                caption='Anzahl Meldungen'
            />
            <Column
                dataField='sendDate'
                caption='Meldungen versendet am'

                dataType='datetime'
            />
            <Column
                dataField='fee'
                caption='Meldegeld'
                format={{ type: 'currency', currency: 'EUR', precision: 2 }} // Euro-Formatierung

            />


        </DataGrid>
    );
};

const GridWithLoadPanel = withLoadPanel(Grid);

export const CompetitionSendClubDetails = ({ data, isLoading, onDataChanged, problems = [], competitionId }) => {
    const { instance, accounts } = useMsal();
    const navigate = useNavigate();
    const [pdfLoading, setPdfLoading] = React.useState(false);

    const onDownloadPDF = React.useCallback(async () => {
        if (!competitionId) {
            notify({
                message: 'Keine Wettkampf-ID vorhanden',
                position: { at: 'bottom center', my: 'bottom center' }
            }, 'error');
            return;
        }

        try {
            setPdfLoading(true);
            const token = await getApiToken(instance, accounts);
            const response = await axios.get(
                `${process.env.REACT_APP_serverEndpoint}/Entry/GetClubProblemsCompetitionPDF?competitionId=${competitionId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    responseType: 'blob'
                }
            );
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const fileName = `Probleme_Wettkampf_${competitionId}.pdf`;
            await openPDFOnDevice(blob, fileName);
        } catch (error) {
            console.error('Fehler beim Herunterladen der PDF:', error);
            notify({
                message: 'Fehler beim Herunterladen der PDF',
                position: { at: 'bottom center', my: 'bottom center' }
            }, 'error');
        } finally {
            setPdfLoading(false);
        }
    }, [competitionId, instance, accounts]);

    const onNavigateToLicenseUpdate = React.useCallback(() => {
        if (!competitionId) {
            notify({
                message: 'Keine Wettkampf-ID vorhanden',
                position: { at: 'bottom center', my: 'bottom center' }
            }, 'error');
            return;
        }
        navigate(`/athlete/license-update?competitionId=${competitionId}`);
    }, [competitionId, navigate]);

    return (
        <div className='competition-send-club-details'>
            <div className='competition-send-club-details-content'>
                <GridWithLoadPanel
                    dat={data}
                    hasData={!!data}
                    loading={isLoading}
                    onDataChanged={onDataChanged}
                    panelProps={{
                        container: '.competition-send-club-details',
                        position: { of: '.competition-send-club-details' }
                    }}
                />
                {problems && problems.length > 0 && (
                    <div className='problems-panel'>
                        <div className='problems-header'>
                            <i className='dx-icon-warning'></i>
                            <span>Probleme ({problems.length})</span>
                        </div>
                        <div className='problems-actions'>
                            <Button
                                text='PDF'
                                icon='exportpdf'
                                type='default'
                                stylingMode='contained'
                                onClick={onDownloadPDF}
                                disabled={pdfLoading}
                            />
                            <Button
                                text='Lizenzen'
                                icon='edit'
                                type='default'
                                stylingMode='outlined'
                                onClick={onNavigateToLicenseUpdate}
                            />
                        </div>
                        <div className='problems-list'>
                            {problems.map((problem, index) => (
                                <div key={index} className='problem-item'>
                                    {problem}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

